var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#123c7f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142,178.5H43.85a8.73,8.73,0,0,1-8.72-8.72V41.12a8.73,8.73,0,0,1,8.72-8.72h71.8l35,35.51V169.78A8.73,8.73,0,0,1,142,178.5ZM43.85,36.76a4.37,4.37,0,0,0-4.36,4.36V169.78a4.37,4.37,0,0,0,4.36,4.36H142a4.37,4.37,0,0,0,4.36-4.36V69.7L113.83,36.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.15,165.42h-7.63v-4.36h7.63a4.37,4.37,0,0,0,4.36-4.37V30.22a4.37,4.37,0,0,0-4.36-4.36H58a4.37,4.37,0,0,0-4.36,4.36v4.36H49.3V30.22A8.73,8.73,0,0,1,58,21.5h98.13a8.73,8.73,0,0,1,8.72,8.72V156.69A8.74,8.74,0,0,1,156.15,165.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.52,70.56h-33.8a2.17,2.17,0,0,1-2.18-2.18V34.58a2.18,2.18,0,0,1,4.36,0V66.2h31.62a2.18,2.18,0,0,1,0,4.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.79,49.85H55.23a2.18,2.18,0,1,1,0-4.36H94.79a2.18,2.18,0,0,1,0,4.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.79,65.11H55.23a2.18,2.18,0,1,1,0-4.36H94.79a2.18,2.18,0,0,1,0,4.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,95.64h-85a2.18,2.18,0,1,1,0-4.36h85a2.18,2.18,0,1,1,0,4.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,112h-85a2.18,2.18,0,0,1,0-4.36h85a2.18,2.18,0,0,1,0,4.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,128.35h-85a2.18,2.18,0,0,1,0-4.36h85a2.18,2.18,0,1,1,0,4.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,144.7h-85a2.18,2.18,0,0,1,0-4.36h85a2.18,2.18,0,1,1,0,4.36Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.89,161.06h-85a2.19,2.19,0,0,1,0-4.37h85a2.19,2.19,0,0,1,0,4.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedInvoice);
export default __webpack_public_path__ + "static/media/closed-invoice.e86f11b70a22f577cc411d954fd58153.svg";
export { ForwardRef as ReactComponent };